import React, { FunctionComponent } from 'react';

import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';
import { InsuredItem } from 'scenes/common/types';
import { getCashKeptAtHome } from 'scenes/home/selectors';
import { HomeFullPageProps } from 'scenes/home/types';

export const STATE_KEY = 'cashKeptAtHome';

const CashKeptAtHomeStep: FunctionComponent<HomeFullPageProps> = ({
  onNext,
  funnelState,
}) => {
  const question = `Is more than $1,000 cash kept in the ${InsuredItem.Home} most days for use by the business?`;
  return (
    <SingleYesNoStep
      question={question}
      stateKey={STATE_KEY}
      defaultStateValue={getCashKeptAtHome(funnelState)}
      onNext={onNext}
    />
  );
};

export default CashKeptAtHomeStep;
